import { configureStore } from '@reduxjs/toolkit'
import { NetworkManager, PollingSubscription, SubscriptionManager } from '@rest-hooks/react'

import location from '../utils/location'

const manager = new NetworkManager()
const subscriptionManager = new SubscriptionManager(PollingSubscription)

const store = configureStore({
  reducer: {
    location
  },
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
    manager.getMiddleware(),
    subscriptionManager.getMiddleware(),
    // PromiseifyMiddleware TODO -> doesn't need anymore in newer versions? (verify)
  ]
})

export default store
